export const environment = {
  appName: 'GroovePlan',
  production: true,
  // apiUrl: 'http://api.grooveplan.fr:80'
  apiUrl: 'https://api.grooveplan.fr',
  googleClientId: '627511892632-cqbbboa8tgueeqo2lkidaq1e6h16mdr0.apps.googleusercontent.com',
  // apiUrl: 'https://57.128.62.45'
  stripePublicKey: 'pk_live_51OezODDteL6yN8NFI802nRWY0GjcIDByvKzUfE3fbRpyZHfO0rn8slEUYAOgueqDkNf8HkrSXh9eEJz47c6X5dBA00dkS2bxOW'
};
